<template>
	<div id="user-access-page" class="placed-backg">

		<div class="container">
			<div class="row mx-0 flex-center-xy page-size">

				<div class="form-container">
					<div class="box-color"><i><u class="fas fa-user"></u></i></div>

					<b-form class="form" @submit.prevent="login()">

						<h6 class="mb-3">Iniciar sesión</h6>
						<hr class="c-hr" />

						<b-form-group>
							<b-form-input type="email" v-model="form.email" required placeholder="Correo electrónico">
							</b-form-input>
						</b-form-group>

						<b-form-group>
							<b-form-input type="password" v-model="form.password" required placeholder="Contraseña">
							</b-form-input>
						</b-form-group>

						<p class="mb-3 text-center">
							<router-link to="/recuperar-contrasena">¿Olvidó su contraseña?</router-link>
							|
							<router-link to="/registrarse">Crear cuenta</router-link>
							<b-form-group class="mt-3">
								<b-button type="submit" class="btn-blue" v-if="!isProcessing" variant="primary">Acceder</b-button>
								<b-button disabled class="btn-blue" v-else variant="primary">Procesando...</b-button>
							</b-form-group>
						</p>


					</b-form>
				</div>

			</div>
		</div>

		<sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block" ref="modal">
			<div class="fa-3x" v-if="modal.icon == ''"><i class="fas fa-spinner fa-pulse"></i></div><br />
			{{ modal.msg }}
			<div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
				<b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close();">OK</b-button>
			</div>
		</sweet-modal>

	</div>
</template>

<script>
	import {mapActions} from 'vuex'
	import mobiscroll from '@mobiscroll/javascript';

	export default {

		data() {
			return {
				isProcessing: false,

				form: {
					email: '',
					password: ''
				},

				modal: {
					msg: '',
					icon: '',
					block: false,
				},
			}
		},

		methods: {
			...mapActions(['authTryLogin']),

			async login(){
				this.isProcessing = true;
				try {
					let response = await this.authTryLogin(this.form)
					if(response.status){
						this.$router.replace('/usuario/mis-datos')
					}
				} catch(e){
					console.error(e)
					mobiscroll.snackbar({
						display: 'top',
						theme: 'ios',
						message: 'Ocurrió un error obteniendo la respuesta: ' + e,
						color: 'warning',
						duration: 7000
					})
				}
				this.isProcessing = false;
			},

			handleErrors (errors) {
				var err = "";

				if (errors.response) {
					if (errors.response.data.errors) {
						jQuery.each(errors.response.data.errors, (k, v) => {
							err += "*" + v[0] + "\n";
						});
					}
				}
				else {
					console.log(errors);
					err = "Error desconocido.";
				}

				this.modal.icon = "error";
				this.modal.msg = err;
				this.modal.block = false;
				this.$refs.modal.open();

			}
		}
	}
</script>
